import React from "react";
import LoginWrapper from "./LoginWrapper";

function UnknownUserView({ onUnknownUserBack, email }) {
  return (
    <LoginWrapper
      left={
        <form>
          <div>
            <h1>Login</h1>
          </div>

          <label htmlFor="email" data-has-error>
            Email
          </label>
          <div className="relative">
            <input
              type="email"
              name="email"
              value={email}
              disabled
              data-has-error
              sz="large"
            />
            <span role="input-error" />
          </div>

          <p className="error">Invalid Email</p>

          <div className="chip danger mt-3">
            Your email is not associated with a new or existing account. You
            need to sign-up with one of our partners to access the app. Contact
            us for assistance
          </div>

          <button
            data-button-type="primary"
            sz="large"
            onClick={onUnknownUserBack}
          >
            Back
          </button>

          <a
            data-button-type="outline"
            role="button"
            sz="large"
            href="https://mystrengthbook.com/contact/"
            target="_blank"
            rel="noopener noreferrer"
            className="!mt-4"
          >
            <span>Contact Us</span>
          </a>
        </form>
      }
    />
  );
}

export default UnknownUserView;
